import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetChallengeInsightProgressTimeInCategorySummaryApplicationService } from '../../../core/application/services/challenge-insights/get-challenge-insight-progress-time-in-category-summary.application-service';
import { ChallengeInsightProgressTimeInCategorySummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-time-in-category.aggregate-root';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';

export class GetChallengeInsightProgressTimeInCategorySummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetChallengeInsightProgressTimeInCategorySummaryApplicationService
  ) {}
  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<ChallengeInsightProgressTimeInCategorySummaryAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
